<app-tab-grid
  i18n-name
  name="Customer Prices"
  [columnDefs]="columnDefs"
  [rowData]="model$ | async"
  [showCreate]="false"
  [showDelete]="false"
></app-tab-grid>
